<template>
    <div class="prompt no-trans" v-loading="loading">
        <el-dialog title="提示" :visible.sync="show1" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose1">
            <div class="dialog_box1">
                <div class="titles">
                    您不是律师，没有权限查看
                </div>
                <div class="btns_box">
                    <div class="btns" @click="show1=false">知道了</div>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="show2" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose2">
            <div class="dialog_box2">
                <div class="form_flex">
                    <div class="titles">律师服务费：</div>
                    <div class="inputs">
                        <el-input v-model="price" placeholder="请输入意向收取的律师服务费金额"></el-input>
                    </div>
                </div>
                <div class="btns_box">
                    <div class="btns1" @click="handle_price">确定</div>
                    <div class="btns2" @click="handleClose2">取消</div>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="show3" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose3">
            <div class="dialog_box1">
                <div class="titles">
                    申请成功，等待分配，请到个人中心查看
                </div>
                <div class="btns_box">
                    <div class="btns" @click="handleClose3">知道了</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            show1:false,//提示  没有权限查看
            show2:false,//提示  律师服务费
            show3:false,//提示  申请成功等待分配
            price:'',
             
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handle_open1(){
            this.show1=true

        },
        handleClose1(){
            this.show1=false
        },
        handle_open2(){
            this.show2=true
        },
        handle_price(){
            if(!this.price){
                alertErr('请输入律师服务费')
                return
            }
            this.show2=false
            this.$emit('handle_orderApply_end',{price:this.price})
        },
        handleClose2(){
            this.show2=false
        },
        handle_open3(){
            this.show3=true
        },
        handleClose3(){
            this.show3=false
        },
        handle_open(i){
            // this.dialogVisible=true
        }



    },

}
</script>
<style scoped lang="less">
.prompt {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 580px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box1{
                   .titles{
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;

                   }
                   .btns_box{
                       padding-top: 36px;
                        .btns{
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            margin: auto;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            border-radius: 8px;
                        }
                   }
                }
                .dialog_box2{
                    .form_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .inputs{
                            width: 400px;
                        }
                    }
                    .btns_box{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 40px;
                        .btns1{
                            width: 104px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                            text-align: center;
                            line-height: 40px;
                        }
                        .btns2{
                            width: 104px;
                            height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            cursor: pointer;
                            line-height: 40px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            margin-left: 20px;
                        }

                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .prompt.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box1 .titles {
        font-size: 14px;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box1 .btns_box {
        padding-top: 16px;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box1 .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        margin: auto;
        font-size: 14px;
        line-height: 1.6;
        border-radius: 8px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        flex-direction: column;
        align-items: stretch;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .form_flex .inputs {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .btns_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .btns_box .btns1 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .prompt.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box2 .btns_box .btns2 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
